import React from 'react';
import {
  ApButtonSecondary,
  ApSimpleDropdown,
} from '@alixpartners/ui-components';

import {
  CHART_TYPES,
  CONTRIBUTIONS,
  DISPLAY_BY,
  DISPLAY_BY_OPTIONS,
  EXPORT_OPTIONS,
  getSpendContributionOptions,
  PERMISSIONS,
} from 'utils/constants';
import { IDisplayByType, IParams, ISelectOption } from 'utils/types';
import QueryParams from 'context/QueryParams';
import {
  Container,
  Divider,
  Top,
  Bottom,
  BreadcrumbsContainer,
  SpaceBetweenDropdowns,
  Wrapper,
} from './ChartOptions.styles';
import { Breadcrumbs } from './Breadcrumbs';
import { ApiContext } from 'context/ApiContext';

const BREADCRUMBS_MAP = {
  '': 'Application spend',
  [CONTRIBUTIONS.THIRD_PARTY]: 'Application Third party spend',
  [CONTRIBUTIONS.PERSONNEL]: 'Application Personnel spend',
};

export const ChartOptionsView = ({
  clearL1,
  clearL2,
  contributions,
  selectedChartOption,
  displayByOption,
  permissions,
  onChartChange,
  onDisplayByChange,
  onSpendContributionChange,
  onExport,
  params,
  setParams,
  selectedL1,
  selectedL2,
}: {
  clearL1: () => void;
  clearL2: () => void;
  contributions?: string;
  params?: IParams;
  setParams: any;
  selectedChartOption: ISelectOption;
  onChartChange: (o: ISelectOption) => void;
  displayByOption: ISelectOption;
  onDisplayByChange: (o: IDisplayByType) => void;
  onSpendContributionChange: (o: ISelectOption) => void;
  permissions: string[];
  onExport: () => {};
  selectedL1?: string;
  selectedL2?: string;
}) => {
  const [isHide, setIsHide] = React.useState<boolean>(false);
  const isPersonnelDisabled = !permissions.includes(
    PERMISSIONS.APPLICATIONS_PERSONNEL
  );
  const spendContributionsOptions =
    getSpendContributionOptions(isPersonnelDisabled);
  const isPersonnel = contributions === CONTRIBUTIONS.PERSONNEL;
  let selectedContribution =
    spendContributionsOptions[isPersonnelDisabled ? 1 : 0];
  if (contributions) {
    if (contributions.length === 2) {
      selectedContribution = spendContributionsOptions[0];
    } else {
      selectedContribution =
        isPersonnel && !isPersonnelDisabled
          ? spendContributionsOptions[2]
          : spendContributionsOptions[1];
    }
  }
  let breadcrumbs = [BREADCRUMBS_MAP[selectedContribution.value]];
  if (selectedL1) {
    breadcrumbs.push(selectedL1);
  }
  if (selectedL2) {
    breadcrumbs.push(selectedL2);
  }

  return (
    <Container>
      <Top>
        <BreadcrumbsContainer>
          <Breadcrumbs
            breadcrumbs={breadcrumbs}
            onClick={(id) => {
              if (id === 0) {
                clearL2();
                clearL1();
              }
              if (id === 1) {
                clearL2();
              }
            }}
          />
        </BreadcrumbsContainer>
        <ApButtonSecondary iconName="tune" onClick={() => setIsHide(!isHide)}>
          {isHide ? 'Show ' : 'Hide '}options
        </ApButtonSecondary>
      </Top>
      <Bottom isHide={isHide}>
        <Wrapper>
          <ApSimpleDropdown
            onChange={(option) => {
              onSpendContributionChange(option as ISelectOption);
            }}
            options={spendContributionsOptions}
            selected={selectedContribution}
          />

          <SpaceBetweenDropdowns />

          <ApSimpleDropdown
            onChange={(option) => {
              // @ts-ignore
              onDisplayByChange(option.value as IDisplayByType);
            }}
            options={[DISPLAY_BY_OPTIONS[0], DISPLAY_BY_OPTIONS[2]].map(
              (option) => ({
                ...option,
                disabled: option.value === DISPLAY_BY.HEADCOUNT && !isPersonnel,
              })
            )}
            selected={displayByOption}
          />

          <Divider />
        </Wrapper>

        <Wrapper>
          <ApSimpleDropdown
            iconName={selectedChartOption.icon}
            onChange={(option) => onChartChange(option as ISelectOption)}
            options={[CHART_TYPES[0], CHART_TYPES[1], CHART_TYPES[2]]}
            selected={selectedChartOption}
          />

          <Divider />

          <ApSimpleDropdown
            iconName="outline_save_alt"
            onChange={onExport}
            options={EXPORT_OPTIONS}
            label="Export"
          />
        </Wrapper>
      </Bottom>
    </Container>
  );
};

export default (props: any) => (
  <ApiContext.Consumer>
    {({ permissions }) => (
      <QueryParams>
        {({ params, setParams }) => (
          <ChartOptionsView
            {...props}
            params={params}
            permissions={permissions}
            setParams={setParams}
          />
        )}
      </QueryParams>
    )}
  </ApiContext.Consumer>
);
